import React from 'react';
import { useDispatch } from 'react-redux';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import bookmark from '../../../../Assets/images/bookmark.svg';
import classes from './saveButton.module.scss';
import { loginRequest } from '../../../../authConfig';
import colors from '../../../../scss/colors';

export default function SaveButton(props) {
  const { id, isSaved, saveDispatcher, unsaveDispatcher, isLarge = false, saving = false } = props;
  const { instance } = useMsal();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();
  const isProfileCompleted = localStorage.getItem('userProfileCompleted') === 'true';
  const userId = localStorage.getItem('UserId');

  const dispatch = useDispatch();

  const saveHandler = () => {
    if (isAuthenticated) {
      if (isProfileCompleted) {
        dispatch(isSaved ? unsaveDispatcher(id) : saveDispatcher(id, userId));
      } else {
        localStorage.setItem('saveJobAfterCompleteProfile', JSON.stringify(id));
        navigate('/dashboard/profile-builder-one');
      }
    } else {
      localStorage.setItem('saveJobAfterLogin', JSON.stringify(id));
      instance
        .loginRedirect({
          ...loginRequest,
          redirectUri: `${window.location.origin}/dashboard/jobs`,
          state: JSON.stringify({ navigate: `/dashboard/jobs/${id}` })
        })
        .catch((e) => {
          console.error(e);
        });
    }
  };

  return (
    <button className={`${classes.saveButton} ${isLarge ? classes.large : ''}`} onClick={saveHandler}>
      {isSaved ? 'Unsave' : 'Save'}
      {saving ? (
        <CircularProgress size="16px" sx={{ color: colors.PRIMARY_BLUE, position: 'absolute', left: '10px' }} />
      ) : (
        <img className={classes.icon} src={bookmark} alt="save" />
      )}
    </button>
  );
}
